import { AutoComplete, FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Box, Grid, Typography } from "@mui/material";
import { UnchosenProfessionalSpecialty } from "./UnchosenProfessionalSpecialty";
import { UnchosenProfessionalInsurances } from "./UnchosenProfessionalInsurances";
import { useTranslation } from "react-i18next";
import { IUnchosenProfessionalFieldsProps } from "./models";
import { UnchosenProfessionalThen } from "./UnchosenProfessionalThen/UnchosenProfessionalThen";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalFields = ({
  unchosenProfessionalCriterions,
}: IUnchosenProfessionalFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} textAlign="end">
        <SwitchInput name="enable" label={t(translationPath + "enable")} />
      </Grid>

      <Box sx={{ pl: 2, pt: 2 }}>
        <Grid
          container
          spacing={2}
          sx={(t) => ({
            pr: 3,
            pl: 1,
            py: 3,
            border: `1px solid ${t.palette.divider}`,
            borderRadius: 2,
          })}
        >
          <Grid item sm={12}>
            <Typography fontWeight="bold">
              {t(translationPath + "if")}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInput
              name="name"
              label={t(translationPath + "name")}
              size="small"
              fullWidth
              autoFocus
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormInput
              type="number"
              size="small"
              name="initialAge"
              fullWidth
              label={t(translationPath + "initial_age") || "Initial Age"}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormInput
              type="number"
              size="small"
              name="finalAge"
              fullWidth
              label={t(translationPath + "final_age") || "Final Age"}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormInput
              type="number"
              size="small"
              name="priority"
              fullWidth
              label={t(translationPath + "priority") || "Priority"}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AutoComplete
              getOptionLabel={({ name }) => name}
              options={unchosenProfessionalCriterions}
              size="small"
              label={t(translationPath + "unchosen_professional_criterion")}
              name="unchosenProfessionalCriterion"
            />
          </Grid>

          <UnchosenProfessionalSpecialty />

          <UnchosenProfessionalInsurances />
        </Grid>

        <UnchosenProfessionalThen />
      </Box>
    </>
  );
};
